import {Fillable, Path, PrimaryKey, RestModel} from 'ng-rest-model';
import {Observable} from 'rxjs/Observable';
import {HasId, Timestamped} from '../../shared/interfaces';

@Path('comments')
export class Comment extends RestModel implements HasId, Timestamped {

    @PrimaryKey()
    id: number;

    @Fillable()
    moderated: boolean;

    @Fillable()
    commenter: string;

    @Fillable()
    text: string;

    created_at: string;
    updated_at: string;

    static toBeModerated(options?: any): Observable<Comment[]> {
        return new this().fetchToBeModerated(options);
    }

    protected fetchToBeModerated(options?: any): Observable<Comment[]> {
        return this.http.get(this.itemUrl('all').build(), options).map((resp: any) => resp.map(c => new Comment().init(c)));
    }

    show(): Observable<Comment> {
        return this.http.put(this.itemUrl(this.id).all('moderated').build(), {moderated: true})
            .map(this.init.bind(this));
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/who-we-are/classes/comment.ts